/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_AppServices_Release_Dtos_CalculateTaxForReleaseItemsRequestDto } from '../models/Wealthlane_AwardService_AppServices_Release_Dtos_CalculateTaxForReleaseItemsRequestDto';
import type { Wealthlane_AwardService_AppServices_Release_Dtos_CalculateTaxForReleaseItemsResponseDto } from '../models/Wealthlane_AwardService_AppServices_Release_Dtos_CalculateTaxForReleaseItemsResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ReleaseItemTaxCalculationService {

    /**
     * @param requestBody
     * @returns Wealthlane_AwardService_AppServices_Release_Dtos_CalculateTaxForReleaseItemsResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppReleaseItemTaxCalculationCalculateTaxForReleaseItems(
        requestBody?: Wealthlane_AwardService_AppServices_Release_Dtos_CalculateTaxForReleaseItemsRequestDto,
    ): CancelablePromise<Wealthlane_AwardService_AppServices_Release_Dtos_CalculateTaxForReleaseItemsResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/release-item-tax-calculation/calculate-tax-for-release-items',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
